import { RouterProvider, createRouter } from '@tanstack/react-router';
import React from 'react';
import ReactDOM from 'react-dom/client';

import '@/styles/globals.css';

import { routeTree } from './routeTree.gen';
import { parseSearch, stringifySearch } from './utils/router';

import 'unfonts.css';

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  parseSearch,
  stringifySearch,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Clear Dark mode from localStorage
try {
  localStorage.removeItem('theme');
} catch (error) {
  console.error('Error clearing theme from localStorage', error);
}

// Render the app
const rootElement = document.getElementById('root')!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}
